import { c as _c } from "react/compiler-runtime";
import styles from "@website/widget/common/components/purchase-menu/components/purchase-card/purchase-card.module.scss";
import { PurchaseCardPropertiesType } from "@website/widget/common/components/purchase-menu/components/purchase-card/purchase-card.types";
import { FC } from "react";
export const PurchaseCard: FC<PurchaseCardPropertiesType> = properties => {
  const $ = _c(4);
  const {
    list
  } = properties;
  let t0;
  if ($[0] !== list) {
    t0 = list ? list.map(_temp2) : null;
    $[0] = list;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className={styles.container}>{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp() {}
function _temp2(item) {
  return item.type === "link" ? <div className={styles.item} key={item.title} onClick={_temp}><span className={styles["item-icon"]}>{item.icon}</span><div className={styles["item-title"]}>{item.title}</div></div> : item.type === "button" ? <div className={styles.item} key={item.title} onClick={item.onClick} role="button"><span className={styles["item-icon"]}>{item.icon}</span><div className={styles["item-title"]}>{item.title}</div></div> : null;
}